import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { STREAMERS } from "../../data/streams";

/* Small blue verified check (Twitter-like) */
function VerifiedCheck({ size = 12, ml = 6 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: "inline-block", marginLeft: ml, verticalAlign: "middle", flex: "0 0 auto" }}
    >
      <circle cx="12" cy="12" r="12" fill="#1DA1F2" />
      <path
        d="M17 9l-6.2 6L7 11.5"
        stroke="#fff"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SearchPage() {
  const [q, setQ] = useState("");

  const list = useMemo(() => {
    const all = Object.entries(STREAMERS).map(([slug, s]) => ({
      slug,
      name: s.displayName || slug,
      avatar: s.avatar || "/nullprofile.png",
    }));
    if (!q.trim()) return all; // default: suggested streamers
    const term = q.trim().toLowerCase();
    return all.filter(x => x.name.toLowerCase().includes(term) || x.slug.includes(term));
  }, [q]);

  return (
    <div style={wrap}>
      <header style={head}>
        <h1 style={title}>SEARCH</h1>
      </header>

      <div style={searchRow}>
        <input
          value={q}
          onChange={(e)=>setQ(e.target.value)}
          placeholder="SEARCH STREAMERS…"
          style={input}
          autoFocus
        />
      </div>

      <div style={hint}>{q ? "RESULTS" : "SUGGESTED STREAMERS"}</div>

      <ul style={listStyle}>
        {list.map((u) => (
          <li key={u.slug} style={item}>
            <Link to={`/${u.slug}`} style={link}>
              <img src={u.avatar} alt="" style={ava} />
              <div style={textCol}>
                {/* name + blue check */}
                <div style={nameRow}>
                  <span style={name}>{u.name}</span>
                  <VerifiedCheck size={12} ml={6} />
                </div>
                <div style={slug}>/{u.slug}</div>
              </div>
              <span style={go}>→</span>
            </Link>
          </li>
        ))}
      </ul>
      <div style={{ height: 72 }} /> {/* spacer for bottom bar */}
    </div>
  );
}

const wrap = { padding: "10px 12px 0", background: "#fff", minHeight: "100vh" };
const head = { padding: "6px 2px 8px", borderBottom: "1px solid #eee" };
const title = { margin: 0, fontSize: 16, letterSpacing: ".5px" };
const searchRow = { padding: "12px 0" };
const input = { width: "100%", border: "1px solid #ddd", borderRadius: 12, padding: "12px 14px", fontSize: 14, textTransform: "uppercase" };
const hint = { fontSize: 12, color: "#666", margin: "4px 2px 8px" };
const listStyle = { listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 8 };
const item = { border: "1px solid #eee", borderRadius: 12 };
const link = { display: "grid", gridTemplateColumns: "42px 1fr auto", gap: 10, alignItems: "center", padding: "10px 12px", textDecoration: "none", color: "#111" };
const ava = { width: 42, height: 42, borderRadius: "50%", objectFit: "cover", border: "1px solid #e5e7eb" };
const textCol = { display: "grid", gap: 2 };
const nameRow = { display: "flex", alignItems: "center", minWidth: 0 };
const name = { fontWeight: 700, fontSize: 14, lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
const slug = { fontSize: 12, color: "#666" };
const go = { fontSize: 16 };
